import config from '../config';
import { ITokenParams } from '../model/IToken';
import axiosInstance from './apis';


export const generateToken = async () => {
    const tokenData = await axiosInstance.request<any, ITokenParams, any>({
    baseURL: config.REACT_APP_AUTH_BASE_URL,
    url: config.REACT_APP_AUTH_ENDPOINT
});
localStorage.setItem('userToken', tokenData?.token)
}

